exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sidebar-nav[data-v-0988f1c0]{height:90vh;overflow:auto;padding-bottom:50px}.sidebar-nav[data-v-0988f1c0]::-webkit-scrollbar{height:16px;overflow:visible;width:16px;display:none}", "", {"version":3,"sources":["/vercel/path0/ui/src/components/slider_view.vue"],"names":[],"mappings":"AACA,8BACE,YAAa,AACb,cAAe,AACf,mBAAqB,CACtB,AACD,iDACE,YAAa,AACb,iBAAkB,AAClB,WAAY,AACZ,YAAc,CACf","file":"slider_view.vue","sourcesContent":["\n.sidebar-nav[data-v-0988f1c0] {\n  height: 90vh;\n  overflow: auto;\n  padding-bottom: 50px;\n}\n.sidebar-nav[data-v-0988f1c0]::-webkit-scrollbar {\n  height: 16px;\n  overflow: visible;\n  width: 16px;\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0988f1c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/slider_view.vue
// module id = 1388
// module chunks = 3